import FormInputTypes from "../UI/FormInputType";

export const initialFormObject = {

  initialData: {
    agentRLookUpId: -1,
    bankRLookUpId: -1,
    contractRLookUpId: -1,
    customerRLookUpId: -1,
    fundRLookUpId: -1,
    insuranceTypeRLookUpId: -1,
    organizationRLookUpId: -1,
    tax: -1,
  }, //
  selectBoxData: {}, //
  sendData: {//

    mode: "add",//
    id: "",//
    overallInfo: {
      'insuranceNumber': "", //
      'contractType': "", //
      'customerId': "", //
      'organizationId': "", //
      'contractId': "", //
      'insuranceTypeId': "", //
      'insurancePrice': "", //
      'paymentType': "", //
      'plate': "", //

      ////
      //  ما اینجا یه وابستگی داریم اگه نوع قرار داد سازمانی بود
      // باید دو تا آرلوکاپ دیده بشن آرلوکاپ مشتری و آرلوکاپ  قرار داد
      //و آرلوکاپ قرار داد یه وابستگی به نتیجه ی جواب آرلوکاپ انتخاب سازمان داره
      // که اینجا دارم اون وابستگی رو توی کلید  ذخیره میکنم

      depContractRLookup: "",//
      // در صورتی که نتیجه ی آرلوکاپ مشتری  اطلاعات سازمانب اومد باید آرلوکاپ قرار داد ظاهر بشه. و اینجا مشخصش میکنم
      showContractRLookUp: false,

    },


    iranInsurance: {
      'firstInstallmentDate': "", //
      'depositBankId': "", //


    }, internalResources: {
      'firstInternalDate': "", //
      'dayCount': "", //
      'internalInstallmentCount': "", //

    },


    financial: {
      'hasAgent': "", //
      'agentId': "", //
      'prePayment': "", //
      'receiveType': "", //
      'fundId': "", //
      'bankId': "", //
      'addedValue': "", //
    },


    furtherInfo: {
      'description': "",//
    }, //

  }
}

export const COMPONENT_TYPE = {
  // Assuming FormInputTypes contains the components
  "string": FormInputTypes.StingType,
  "number": FormInputTypes.NumberType,
  "longNumber": FormInputTypes.LongNumberType,
  "longNumber+2float": FormInputTypes.LongNumber_2floatType,
  "smallNumber": FormInputTypes.SmallNumberType,
  "smallFloat": FormInputTypes.SmallFloatType,
  "longFloat": FormInputTypes.LongFloatType,
  "date": FormInputTypes.DateType,
  "time": FormInputTypes.TimeType,
  "mobile": FormInputTypes.MobileType,
  "telephone": FormInputTypes.TelephoneType,
  "email": FormInputTypes.EmailType,
  "price": FormInputTypes.PriceType,
  "color": FormInputTypes.ColorType,
  "year": FormInputTypes.YearType,
  "month": FormInputTypes.MonthType,
  "day": FormInputTypes.DayType,
  "selectBox": FormInputTypes.SelectBoxType,
  "cashBox": FormInputTypes.CashBoxType,
  "rlookup": FormInputTypes.RLookupType,
  "file": FormInputTypes.FileType,
  "textarea": FormInputTypes.TextareaType,//
  // اگه در آینده بک اند تایپ جدیدی اضفه کرد باید اینجا اضفه کنیم و کامپوننت خودشو اضافه کنیم
};


